<router-outlet></router-outlet>



// WEBPACK FOOTER //
// /app/src/app/layouts/blank/blank.component.html